/* STORE ROUTE */
export const HOME_ROUTE = "/home";
export const PRODUCTS_ROUTE = "/produtos";
export const EXPIRED_PRODUCTS_ROUTE = "/produtos-vencidos";
export const USERS_ROUTE = "/usuarios";
export const SETTINGS_ROUTE = "/configuracao";

/* ADMIN STORE */
export const ADMIN_ROUTE = "/admin";
export const ADMIN_STORES_ROUTE = "/admin/lojas";
export const ADMIN_USERS_ROUTE = "/admin/usuarios";
export const ADMIN_EXPIRY_DATE_CONTROL_ROUTE = "/admin/controle-validade";
export const ADMIN_IMPORT_ROUTE = "/admin/importacao";
export const ADMIN_SETTINGS_ROUTE = "/admin/configuracao";

/* SUPER ADMIN */
export const SUPER_ADMIN_ROUTE = "/superadmin";
export const SUPER_ADMIN_CLIENTS_ROUTE = "/superadmin/clientes";
export const SUPER_ADMIN_USERS_ROUTE = "/superadmin/usuarios";

/* EXTERNAL LINKS */
export const PRIVACY_POLICY_URL = "https://cesarsoftdevelopment.github.io/controdata-privacy-policy/";

/* MESSAGES */
export const messages = {
    /* CLIENT MESSAGES */
    clientCreatedSuccess: "Cliente criado com sucesso!",
    clientCreatedError: "Erro ao criar cliente",
    clientEditedSuccess: "Cliente editado com sucesso!",
    clientEditedError: "Erro ao editar cliente.",
    clientDeletedSuccess: "Cliente excluído com sucesso!",
    clientDeletedError: "Erro ao excluir cliente.",
    loadClientsError: "Erro ao carregar clientes"
}